import { render, staticRenderFns } from "./PesquisasDash.vue?vue&type=template&id=f48121ea&"
import script from "./PesquisasDash.vue?vue&type=script&lang=js&"
export * from "./PesquisasDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports